import type { ExamUserRole } from "@/lib/exam-role-from-session"

import { EXAM_MANAGEMENT_ROOT, EXAM_MANAGEMENT_MY_EXAMS_PATH } from "./exam-management-paths"
import { isExamLockPath } from "./exam-lock-shell"

const EM_ROOT = `/${EXAM_MANAGEMENT_ROOT}`

/** Paths a Student persona may stay on under Exam Management. */
const STUDENT_ALLOWED_PREFIXES = [
  `${EM_ROOT}/my-exams`,
  `${EM_ROOT}/results`,
  `${EM_ROOT}/students`,
  `${EM_ROOT}/my-dashboard`,
] as const

export function isExamManagementStudentAllowedPath(pathname: string): boolean {
  if (isExamLockPath(pathname)) return true
  return STUDENT_ALLOWED_PREFIXES.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`),
  )
}

/**
 * Sidebar nav for Exam Management follows the active route, not only session role.
 * Direct links to My Exams / Results must show the two-row student layout even when
 * the demo session is still Administrator until the user picks Exam persona.
 */
export function resolveExamNavRole(
  sessionRole: ExamUserRole,
  pathname: string,
): ExamUserRole {
  if (isExamManagementStudentAllowedPath(pathname)) {
    return "Student"
  }
  return sessionRole
}

/** Admin or faculty surfaces under `/exam-management/…` that students should not browse. */
export function isExamManagementAdminOnlyPath(pathname: string): boolean {
  if (!pathname.startsWith(`${EM_ROOT}/`) && pathname !== EM_ROOT) return false
  if (pathname === EM_ROOT || pathname === `${EM_ROOT}/`) return false
  return !isExamManagementStudentAllowedPath(pathname)
}

export { EXAM_MANAGEMENT_MY_EXAMS_PATH }
